import { render, staticRenderFns } from "./dcn.vue?vue&type=template&id=0bfaf8ac&scoped=true"
import script from "./dcn.vue?vue&type=script&lang=js"
export * from "./dcn.vue?vue&type=script&lang=js"
import style0 from "./dcn.vue?vue&type=style&index=0&id=0bfaf8ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfaf8ac",
  null
  
)

export default component.exports